import GolfIcon from '@/components/GolfIcon';
import { IonButton } from '@ionic/react';
import { useTranslation } from 'react-i18next';
import HorizontalScrollMedia from '@/components/HorizontalScrollMedia';

interface ClubActionButtonsProps {
  course: {
    name: string;
    address?: string;
    city?: string;
    phone?: string;
    websiteUrl?: string;
  };
  onPlayClick: () => void;
}

const ClubActionButtons: React.FC<ClubActionButtonsProps> = ({ course, onPlayClick }) => {
  const { t } = useTranslation();

  return (
    <HorizontalScrollMedia disableArrows>
      <IonButton fill="solid" color="primary" className="my-2" onClick={onPlayClick}>
        <div className="flex flex-col md:flex-row items-center gap-1 px-4">
          <GolfIcon name="golf" className="size-6 invert" themeAware={false} />
          <span className="text-sm">{t('play')}</span>
        </div>
      </IonButton>
      {course.address && (
        <IonButton 
          fill="solid" 
          color="secondary" 
          target="_blank" 
          className="my-2" 
          href={`https://www.google.com/maps/search/?api=1&query=${course.name}, ${course.address}, ${course.city}`}
        >
          <div className="flex flex-col md:flex-row items-center gap-1 px-4">
            <GolfIcon name="navigation" className="size-6" />
            <span className="text-sm">{t('itinerary')}</span>
          </div>
        </IonButton>
      )}
      {course.phone && (
        <IonButton 
          className="my-2" 
          onClick={() => window.open(`tel:${course.phone}`, '_blank')} 
          fill="solid" 
          color="secondary"
        >
          <div className="flex flex-col md:flex-row items-center gap-1 px-4">
            <GolfIcon name="call" className="w-6 h-6" />
            <span className="text-sm">{t('call')}</span>
          </div>
        </IonButton>
      )}
      {course.websiteUrl && (
        <IonButton 
          className="my-2" 
          fill="solid" 
          color="secondary" 
          href={course.websiteUrl} 
          target="_blank"
        >
          <div className="flex flex-col md:flex-row items-center gap-1 px-4">
            <GolfIcon name="global" className="w-6 h-6" />
            <span className="text-sm">{t('website')}</span>
          </div>
        </IonButton>
      )}
    </HorizontalScrollMedia>
  );
};

export default ClubActionButtons;
